import { inject } from "@angular/core";
import { CanActivateFn, CanActivateChildFn } from "@angular/router";
import { KeycloakAuthService } from "../auth/keycloak.service";

function requireAuth(): boolean {
  const authService = inject(KeycloakAuthService);

  if (authService.isAuthenticated()) {
    return true;
  }

  void authService.login();
  return false;
}

export const AuthGuard: CanActivateFn = () => requireAuth();

export const AuthChildGuard: CanActivateChildFn = () => requireAuth();
